/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import { LocaleCode } from "@ifit/rapport-core";
import Rapport from ".";
import { I18nWebview, IRapportWebPackage } from "./i18n-webview";

type ContextProps = {
  i18n: I18nWebview;
  locale: LocaleCode;
};

export const I18nContext = React.createContext<ContextProps>(null);

type I18nProviderPropsBase = {
  locale: LocaleCode;
};

interface I18nProviderPropsWithPackage extends I18nProviderPropsBase {
  rapportPackage: IRapportWebPackage;
  instance?: undefined;
}

interface I18nProviderPropsWithInstance extends I18nProviderPropsBase {
  instance: I18nWebview;
  rapportPackage?: undefined;
}

type I18nProviderProps =
  | I18nProviderPropsWithInstance
  | I18nProviderPropsWithPackage;

export const I18nConsumer = I18nContext.Consumer;

export const I18nProvider: React.FC<I18nProviderProps> = ({
  instance,
  rapportPackage,
  locale,
  children
}) => {
  const i18n = instance || (Rapport.initI18n(rapportPackage) as I18nWebview);
  i18n.setLocaleSync(locale);
  return (
    <I18nContext.Provider value={{ i18n, locale }}>
      {children}
    </I18nContext.Provider>
  );
};

export default I18nContext;
